module.exports = __webpack_public_path__ + "03b6e289c8c571175b5c11a31e377676.svg";